import { API_ENDPOINT } from 'src/config/env.config';
import { baseApi } from './axios';
import {
	BaseAPIResponse,
	CreatePaymentForInterviewOrPrepInput,
	CreatePaymentInput,
	GetPaymentByIdAPIResponse,
	GetPaymentStatusAPIResponse,
	GetApplyCouponResponse,
	CreatePaymentForBenchmarkingTest,
	GetCreatePaymentForBenchmarkingResponse,
	CreatePaymentForDrive,
	CompletePaymentForDrive,
} from 'types';

const baseUrl = `${API_ENDPOINT}/payment`;

export const createPaymentForBenchmarking = async (
	payload: CreatePaymentForBenchmarkingTest,
): Promise<GetCreatePaymentForBenchmarkingResponse> => {
	const response = await baseApi.post(`${baseUrl}/create-benchmarking-payment`, { payload });
	return response.data;
};

export const completeBenchmarkingPaymentById = async (args: { id: string }): Promise<BaseAPIResponse> => {
	const response = await baseApi.post(`${baseUrl}/complete-benchmarking-payment`, { ...args });
	return response.data;
};

export const cancelBenchmarkingPaymentById = async (id: string): Promise<BaseAPIResponse> => {
	const response = await baseApi.post(`${baseUrl}/cancel-benchmarking-payment`, { id });
	return response.data;
};

// old routes
export const createPaymentForJap = async (payload: CreatePaymentInput): Promise<GetPaymentByIdAPIResponse> => {
	const response = await baseApi.post(`${baseUrl}/create`, { payload });
	return response.data;
};
export const applyCoupon = async ({ code }: { code: string }): Promise<GetApplyCouponResponse> => {
	const response = await baseApi.post(`${baseUrl}/applyCoupon`, { code });
	return response.data;
};

export const completePaymentById = async (args: {
	id: string;
	isForInterviewOrPrep: boolean;
}): Promise<BaseAPIResponse> => {
	const response = await baseApi.post(`${baseUrl}/complete-payment`, { ...args });
	return response.data;
};

export const cancelPaymentById = async (id: string): Promise<BaseAPIResponse> => {
	const response = await baseApi.post(`${baseUrl}/cancel-payment`, { id });
	return response.data;
};

export const createPaymentForInterviewOrPrep = async (
	payload: CreatePaymentForInterviewOrPrepInput,
): Promise<GetPaymentByIdAPIResponse> => {
	const response = await baseApi.post(`${baseUrl}/create-payment-for-interview-or-prep`, { payload });
	return response.data;
};

export const getPaymentStatusForInterviewOrPrep = async (
	isForInterview: boolean,
): Promise<GetPaymentStatusAPIResponse> => {
	const response = await baseApi.post(`${baseUrl}/payment-status`, { isForInterview });
	return response.data;
};

export const createPaymentForDrive = async (
	data: CreatePaymentForDrive,
): Promise<GetCreatePaymentForBenchmarkingResponse> => {
	const response = await baseApi.post(`${baseUrl}/create-payment-for-drive`, data);
	return response.data;
};

export const completePaymentForDrive = async (data: CompletePaymentForDrive): Promise<BaseAPIResponse> => {
	const response = await baseApi.post(`${baseUrl}/complete-payment-for-drive`, data);
	return response.data;
};
